import { render, staticRenderFns } from "./WalletMetadataManagement.vue?vue&type=template&id=3bc63ccd&scoped=true"
import script from "./WalletMetadataManagement.vue?vue&type=script&lang=js"
export * from "./WalletMetadataManagement.vue?vue&type=script&lang=js"
import style0 from "./WalletMetadataManagement.vue?vue&type=style&index=0&id=3bc63ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc63ccd",
  null
  
)

export default component.exports